import React, { useEffect, useRef } from 'react'
import { useState } from 'react';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"; 
import { formatDate, formatDateDDMMYYYY, formatDateTxt, formatDateTxt2 } from "../../utils/formatDate.js";
import FacebookShare from '../ShareSocial/FacebookShare.js';
import TwitterShare from '../ShareSocial/TwitterShare.js';
import LineShare from '../ShareSocial/LineShare.js';
import LinkCopy from '../ShareSocial/LinkCopy.js';
import { Link } from 'react-router-dom';

function PreviewPromo({ type,save,close,cover,title,desc,datePublish,dateEff,dateEnd,note,discount,dateDis }) {
  useButtonDynamicStyles(
      textSearchBtn,
      textResetBtn,
      textCreateBtn,
      colorSearchBtn,
      colorResetBtn,
      colorCreateBtn,
      iconSearchBtn,
      iconResetBtn,
      iconCreateBtn,
      hoverSearchBtn,
      hoverResetBtn,
      hoverCreateBtn,
      textSaveBtn,
      textCancleBtn,
      colorSaveBtn,
      colorCancleBtn,
      hoverSaveBtn,
      hoverCancleBtn,
      colorEditBtns,
      hoverEditBtns
  );
  console.log("datePublish",datePublish);
  const [dataId, setDataId] = useState(null);
  const imgList = useRef([])
  const [listDatasSlider1, setListDatasSlider1] = useState([{
    original: "https://dev-asp.verkoffice.com/assets/images/banner-promo-priv.png",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
}]);
const base64ToBlob = (dataURL) => {
    const [prefix, base64] = dataURL.split(',');
    const contentType = prefix.match(/data:(.*);base64/)[1];
    const byteCharacters = atob(base64);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};  

const renderItem = (item) => {
    return (
        <div className='image-gallery-item'>
            <img src={item.original} alt={item.original} className='im-banner' />
        </div>
    );
};
const [dataCardDetail, setDataCardDetail] = useState({
    txtDiscount: '',
    txtTitle: '',
    txtDetail: '',
    publishDate: '',
    effectiveDate: '',
    endDate: '',
    note: '',
    shareFB: '',
    shareX: '',
    shareXtext: 'All Season',
    shareLine: '',
    shareLineText: 'All Season',
    link: '',
});

const CustomLeftNav = ({ onClick, disabled }) => (
    <button
        type="button"
        className="custom-arrow custom-left-arrow"
        disabled={disabled}
        onClick={onClick}
        aria-label="Previous Slide"
    />
);

const CustomRightNav = ({ onClick, disabled }) => (
    <button
        type="button"
        className="custom-arrow custom-right-arrow"
        disabled={disabled}
        onClick={onClick}
        aria-label="Next Slide"
    />
);

// console.log('coverPreview',cover)
useEffect(()=>{
    let updatedInfoListDatas = []
    // for(let i = 0;i<imgList.current.length;i++){
    //     URL.revokeObjectURL(imgList.current[i])        
    // }
    imgList.current = []
    for(let i = 0;i<cover.length;i++){
        // let imgBlob = base64ToBlob(cover[i].src)
        // const imgUrl = URL.createObjectURL(imgBlob);
        // imgList.current.push(imgUrl)
        updatedInfoListDatas.push({
            original: cover[i].src,
            thumbnail: cover[i].src,
        })
    }
    // console.log('imgList',imgList.current)
    
    // updatedInfoListDatas.push({
    //     original: imgList.current,
    //     thumbnail: imgList.current,
    // })

    setListDatasSlider1(updatedInfoListDatas);
    
},[cover])


useEffect(() => {
    let id = new URLSearchParams(window.location.search).get("id");
        if (id) {
            setDataId(id);
        }
}, [type])

return (
    <div className="container-fluid w-100">
        <style>
                {`
                    .bd-bottom04, .bd-bottom05 {
                        border-bottom: 2px solid #000;
                        display: block;
                        padding: 1px 0;
                        width: 60% !important;
                    }
                    .sty-promo1 {
                        display: flex;
                        justify-content: center;
                        align-items: start;
                        background-color: #ffffff;
                        padding: 25px;
                    }
                    .image-gallery-item img {
                        width: 800px !important;
                        height: 450px !important;
                    }
                `}
        </style>
        <div className="info-container">
            <div className="info-data">
                <div className="mx-10 my-5">
                    <div className="row">
                        <div className="col-12 col-md-6 px-0">
                            <div className="image-gallery-wrapper">
                                <ImageGallery
                                    items={listDatasSlider1}
                                    autoPlay={true}
                                    showPlayButton={false}
                                    showThumbnails={true}
                                    showFullscreenButton={false}
                                    showBullets={false}
                                    showNav={true}
                                    renderItem={renderItem}
                                    renderLeftNav={(onClick, disabled) => (
                                        <CustomLeftNav onClick={onClick} disabled={disabled} />
                                    )}
                                    renderRightNav={(onClick, disabled) => (
                                        <CustomRightNav onClick={onClick} disabled={disabled} />
                                    )}
                                />
                            </div>
                        </div>

                        <div className='col-12 col-md-6 sty-promo1'>
                            <div width={'100%'}>
                                <h2 className="fontBold"> <span className="font-size10 fontBold">{discount} </span></h2>
                                <p className="bd-bottom04"></p>
                                <p className="fontBold font-size06 mb-0">{title}</p>
                                {/* <p className="fontBold font-size06">SHOPPING SALE</p> */}
                                <p className="font-size02 colorBlack01 fontReg mb-0 mb-md-1 text-underline">DETAIL</p>
                                <p className="font-size02 colorBlack01 fontReg"><div dangerouslySetInnerHTML={{ __html: desc}}></div></p>
                                {/* <p className="font-size11 colorBlack01 fontBold">{formatDateTxt(dateEff)} - {formatDateTxt(dataEnd)}</p> */}
                                {/* <p className="font-size11 colorBlack01 fontBold">{`${dateEff} - ${dataEnd}`}</p> */}
                                <p className="font-size11 colorBlack01 fontBold">
                                    {`Publish Date: ${formatDateDDMMYYYY(datePublish)}`}
                                    {/* {dateDis === dateEnd 
                                        ? formatDateTxt2(dateDis) 
                                        : `${formatDateTxt2(dateDis)} - ${formatDateTxt2(dateEnd)}`} */}
                                </p>
                                <p className="font-size03 colorBlack01 fontReg">{note}</p>
                                <div className="d-flex justify-content-start w-100">
                                    <div className='d-flex flex-row align-items-center'>
                                        <font className="font-size02 fontBold colorBlack01 text-decoration-none">
                                            SHARE
                                        </font>
                                       
                                        <div className='ms-3 w-100'>
                                            <svg width={150} height={30} viewBox="0 0 150 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2013_5039)">
                                                    <Link className='cursor-none'>
                                                        <path d="M14.8394 29.8267C23.035 29.8267 29.6789 23.1498 29.6789 14.9134C29.6789 6.67694 23.035 0 14.8394 0C6.64384 0 0 6.67694 0 14.9134C0 23.1498 6.64384 29.8267 14.8394 29.8267Z" fill="#0767FF" />
                                                        <path d="M16.1014 11.2636V13.1751H18.5531L18.149 15.8069H16.1014V22.0939H13.2941V15.8069H10.9609V13.1751H13.2941V10.5271C13.2941 8.98381 14.5388 7.73291 16.0745 7.73291H18.7093V10.1102H17.2437C16.6079 10.1102 16.096 10.63 16.096 11.2636H16.1014Z" fill="white" />
                                                    </Link>
                                                    <Link className='cursor-none'>
                                                        <path d="M54.941 29.8267C63.1366 29.8267 69.7804 23.1498 69.7804 14.9134C69.7804 6.67694 63.1366 0 54.941 0C46.7454 0 40.1016 6.67694 40.1016 14.9134C40.1016 23.1498 46.7454 29.8267 54.941 29.8267Z" fill="black" />
                                                        <path d="M56.1015 14.0955L60.6493 9.19482H59.5393L55.6112 13.4295L52.4644 9.19482H48.9674L53.6714 15.5197L48.9297 20.6316H50.0451L54.1671 16.1858L57.4702 20.6316H60.9672L56.1069 14.0901L56.1015 14.0955ZM54.7221 15.5793L54.2264 14.9132L50.5839 10.0125H52.0495L55.04 14.036L55.5358 14.702L59.3345 19.814H57.8689L54.7221 15.5793Z" fill="white" />
                                                    </Link>
                                                    <Link className='cursor-none'>
                                                        <path d="M95.0582 30.0001C103.254 30.0001 109.898 23.3231 109.898 15.0867C109.898 6.85028 103.254 0.17334 95.0582 0.17334C86.8626 0.17334 80.2188 6.85028 80.2188 15.0867C80.2188 23.3231 86.8626 30.0001 95.0582 30.0001Z" fill="#1ABA20" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M95.0547 8.13916C99.0905 8.13916 102.383 10.8305 102.383 14.1013C102.383 15.8558 101.488 17.3774 100.017 18.4659C96.9514 21.1139 95.2487 21.8558 95.2487 21.8558C94.5913 22.2078 94.4727 22.0128 94.5482 21.3901C94.6236 21.0002 94.7044 20.4911 94.7044 20.4911C94.7799 20.1392 94.3919 20.0633 94.241 20.0254H94.1656C90.5177 19.6735 87.7266 17.1392 87.7266 14.1013C87.7266 10.8251 91.0242 8.13916 95.0547 8.13916Z" fill="white" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M90.2031 15.8177H92.4932V15.195H90.9036V12.5037H90.2031V15.8177ZM92.8811 15.8177H93.5816V12.5037H92.8811V15.8177ZM96.4482 12.5037V14.5289L94.8963 12.5037H94.3144V15.8177H95.0149V13.8304L96.5667 15.8177H97.1487V12.5037H96.4482ZM98.582 15.2329V14.4531H100.058V13.8683H98.582V13.1264H100.058V12.5037H97.8869V15.8177H100.058V15.2329H98.582Z" fill="#1ABA20" />
                                                    </Link>
                                                    <Link className='cursor-none'>
                                                        <path d="M135.16 29.8267C143.355 29.8267 149.999 23.1498 149.999 14.9134C149.999 6.67694 143.355 0 135.16 0C126.964 0 120.32 6.67694 120.32 14.9134C120.32 23.1498 126.964 29.8267 135.16 29.8267Z" fill="#BD3A16" />
                                                        <path d="M140.284 9.76366C139.67 9.14633 138.851 8.80518 137.978 8.80518C137.105 8.80518 136.286 9.14633 135.672 9.76366L133.856 11.5886C133.759 11.686 133.705 11.816 133.705 11.9568C133.705 12.0976 133.759 12.2276 133.856 12.325C134.061 12.5308 134.389 12.5308 134.589 12.325L136.404 10.5001C137.272 9.62828 138.684 9.62828 139.551 10.5001C140.419 11.372 140.419 12.7907 139.551 13.6626L137.735 15.4875C137.315 15.9099 136.76 16.1427 136.162 16.1427C135.564 16.1427 135.009 15.9099 134.589 15.4875C134.298 15.1951 134.093 14.8323 134.001 14.4315C133.969 14.2961 133.888 14.1824 133.77 14.1066C133.651 14.0362 133.511 14.0146 133.376 14.0471C133.242 14.0795 133.128 14.1608 133.053 14.2799C132.983 14.399 132.956 14.5398 132.994 14.6752C133.134 15.26 133.43 15.7961 133.856 16.2239C134.47 16.8413 135.289 17.1824 136.162 17.1824C137.035 17.1824 137.854 16.8413 138.468 16.2239L140.284 14.399C140.898 13.7817 141.238 12.9586 141.238 12.0813C141.238 11.2041 140.898 10.381 140.284 9.76366Z" fill="white" />
                                                        <path d="M135.727 17.5019L133.911 19.3268C133.044 20.1987 131.632 20.1987 130.765 19.3268C129.897 18.455 129.897 17.0362 130.765 16.1644L132.581 14.3395C133.448 13.4676 134.86 13.4676 135.727 14.3395C136.018 14.6319 136.223 14.9947 136.315 15.3954C136.347 15.5308 136.428 15.6445 136.546 15.7203C136.665 15.7907 136.805 15.8178 136.94 15.7799C137.074 15.7474 137.188 15.6662 137.263 15.5471C137.333 15.4279 137.36 15.2871 137.322 15.1518C137.182 14.5669 136.886 14.0308 136.46 13.603C135.846 12.9857 135.027 12.6445 134.154 12.6445C133.281 12.6445 132.462 12.9857 131.848 13.603L130.032 15.4279C129.418 16.0453 129.078 16.8684 129.078 17.7456C129.078 18.6229 129.418 19.446 130.032 20.0633C130.646 20.6806 131.465 21.0218 132.338 21.0218C133.211 21.0218 134.03 20.6806 134.644 20.0633L136.46 18.2384C136.665 18.0326 136.665 17.7023 136.46 17.5019C136.255 17.3016 135.927 17.2962 135.727 17.5019Z" fill="white" />
                                                    </Link>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2013_5039">
                                                        <rect width={150} height={30} fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-100 d-flex justify-content-center align-items-center'>
                    <Row className='w-90 mt-5'>
                        <Col xs={12} className='d-flex justify-content-center align-items-center'>
                            <button
                                className="btn-cancle01 me-4"
                                onClick={() => close()}
                            >
                                BACK
                            </button>
                            <button
                                className="btn-save01"
                                onClick={(e) => 
                                    save()
                                }
                            >
                                SAVE
                            </button>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>
    
)
}

export default PreviewPromo;